import { Truck } from '@phosphor-icons/react'

import type { TDelivery } from '@/main/app/schema'

import { formatPhoneNumber } from '@/cart/utils/formatPhoneNumber'

export function DeliveryValues({ values }: { values: TDelivery['shippingDetail'] }) {
  const isRoundTrip = values.deliveryType === 'roundtrip'
  const isMultiTrip = values.deliveryType === 'multitrip'
  const isOnlyDelivery = values.deliveryType === 'deliveryonly'
  const isOnlyReturn = values.deliveryType === 'returnonly'

  return (
    <>
      <p className="twc-mb-2 twc-leading-[1.5]">
        <strong>Delivery service requested (ACME arranges courier)</strong>{' '}
        <Truck weight="bold" size={18} className="twc-inline align-text-top" />
        <br />
        <em className="twc-text-[15px]">
          Quote for{' '}
          {isMultiTrip
            ? 'Multiple locations for delivery (Deliver and Return from two separate locations)'
            : isOnlyDelivery
            ? 'Delivery Only (I will return to ACME myself)'
            : isOnlyReturn
            ? 'Return Only (I will pick-up from ACME myself)'
            : 'Round Trip Delivery (Delivery and Return to/from the same location)'}
        </em>
      </p>
      {/* <p className="twc-mt-0 twc-text-[15px] twc-leading-[1.75]">
        {!isOnlyReturn && (
          <>
            <strong className="twc-font-semibold">Delivery drop-off window:</strong>{' '}
            {values?.startTime}
            <br />
          </>
        )}
        {!isOnlyDelivery && (
          <>
            <strong className="twc-font-semibold">Return pick-up window:</strong> {values?.endTime}
          </>
        )}
      </p> */}

      {!isOnlyReturn && (
        <p className="twc-text-[15px] twc-border-l-2 twc-border-l-brand twc-pl-2">
          <strong>{isRoundTrip ? 'Deliver and Return to/from:' : 'Deliver to:'}</strong>
          <br />
          <strong className="twc-font-medium">{values.deliveryBusiness}</strong>
          <br />
          <strong className="twc-font-medium">ATTN:</strong> {values.deliveryContact},{' '}
          {formatPhoneNumber(values.deliveryPhone)}
          <br />
          {!values.deliveryUnit
            ? values.deliveryAddress
            : `${values.deliveryAddress}, ${values.deliveryUnit}`}
          , {values.deliveryCity}, NY {values.deliveryZip}
          <br />
          <strong className="twc-font-medium">Delivery drop-off window:</strong> {values?.startTime}
          {isRoundTrip && (
            <>
              <br />
              <strong className="twc-font-medium">Return pick-up window:</strong> {values?.endTime}
            </>
          )}
        </p>
      )}
      {(isMultiTrip || isOnlyReturn) && (
        <p className="twc-text-[15px] twc-border-l-2 twc-border-l-blue-400 twc-pl-2">
          <strong>Return from:</strong>
          <br />
          <strong className="twc-font-medium">{values.returnBusiness}</strong>
          <br />
          <strong className="twc-font-medium">ATTN:</strong> {values.returnContact},{' '}
          {formatPhoneNumber(values.returnPhone)}
          <br />
          {!values.returnUnit
            ? values.returnAddress
            : `${values.returnAddress}, ${values.returnUnit}`}
          , {values.returnCity}, NY {values.returnZip}
          <br />
          <strong className="twc-font-medium">Return pick-up window:</strong> {values?.endTime}
        </p>
      )}
    </>
  )
}
